import { useEffect, useState } from "react";
import { properties } from "../../../properties";

const BillingAddress = ({ setShowPayment, checkoutParam, isFormDisabled, setisFormDisabled }) => {
    const [cardBillingAddress, setCardBillingAddress] = useState({
        card_billingaddress_customerName: "",
        card_billingaddress_country: "",
        card_billingaddress_addressLine1: "",
        card_billingaddress_addressLine2: "",
        card_billingaddress_city: "",
        card_billingaddress_state: "",
        card_billingaddress_phone: "",
        card_billingaddress_postCode: ""
    });

    function addCustomerName(e) {
        setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_customerName: e.target.value }); 
    }

    function addBillingCountry(e) {
        setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_country: e.target.value });
    }

    function addAddressLine1(e) {
        setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_addressLine1: e.target.value });
    }

    function addAddressLine2(e) {
        setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_addressLine2: e.target.value });
    }

    function addZip(e) {
        setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_postCode: e.target.value });
    }

    function addCity(e) {
        setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_city: e.target.value });
    }

    function addState(e) {
        setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_state: e.target.value });
    }

    function addPhone(e) {
        setCardBillingAddress({ ...cardBillingAddress, card_billingaddress_phone: e.target.value });
    }

    const handleAddressSubmit = () => {
        setShowPayment(true);
        setisFormDisabled(true);
    }

    return (
        <div id="cardBillingAddress">
            <fieldset disabled={isFormDisabled === true}>
                <div className="form-group">
                    <div className="control-label">
                        Customer Name<span>{!checkoutParam.customerName && <span className="mandatory-indicator">*</span>}</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="card_billingaddress_customerName" id="card_billingaddress_customerName" value={cardBillingAddress.card_billingaddress_customerName} onChange={addCustomerName} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Billing Country<span>{!checkoutParam.countryCode && <span className="mandatory-indicator">*</span>}</span>
                    </div>
                    <div className="col-sm-5">
                        {<select className="form-control" id="card_billingaddress_country" name="card_billingaddress_country" value={cardBillingAddress.card_billingaddress_country} onChange={addBillingCountry}>
                            {properties.COUNTRY_LIST.map((property) => <option value={property.code} key={property.code}>{property.name}</option>)}
                        </select>}
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Address Line 1<span>{!checkoutParam.addressLine1 && <span className="mandatory-indicator">*</span>}</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="card_billingaddress_addressLine1" id="card_billingaddress_addressLine1" value={cardBillingAddress.card_billingaddress_addressLine1} onChange={addAddressLine1} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Address Line 2
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="card_billingaddress_addressLine2" id="card_billingaddress_addressLine2" value={cardBillingAddress.card_billingaddress_addressLine2} onChange={addAddressLine2} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Postal Code / Postcode / ZIP Code<span>{!checkoutParam.zip && <span className="mandatory-indicator">*</span>}</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="card_billingaddress_postCode" id="card_billingaddress_postCode" value={cardBillingAddress.card_billingaddress_postCode} onChange={addZip} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        City / Town<span>{!checkoutParam.city && <span className="mandatory-indicator">*</span>}</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" id="card_billingaddress_city" name="card_billingaddress_city" value={cardBillingAddress.card_billingaddress_city} onChange={addCity} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        State / Province / Region
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="card_billingaddress_state" id="card_billingaddress_state" value={cardBillingAddress.card_billingaddress_state} onChange={addState} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Phone Number
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="card_billingaddress_phone" id="card_billingaddress_phone" value={cardBillingAddress.card_billingaddress_phone} onChange={addPhone} />
                    </div>
                </div>
                {!isFormDisabled && <button id="wps-address-submit-btn" type="submit" className="btn btn-primary billing-address-btn" onClick={handleAddressSubmit}>Proceed to Checkout</button>}

            </fieldset>
        </div>
    )
}
export default BillingAddress;